import Vue from 'vue'
import App from '../App.vue'
import store from '../store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import '../assets/tailwind.css'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import TreeView from 'vue-json-tree-view'

let isBootstrapped = false

const configureApp = function () {
  if (isBootstrapped) {
    return
  }

  Vue.use(TreeView)
  Vue.use(Antd)
  Vue.use(VueAxios, axios)
  Vue.config.productionTip = false

  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('auth_token')
      const expires = localStorage.getItem('auth_expires')
      if (token && expires && Date.now() < parseInt(expires)) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    (error) => Promise.reject(error)
  )

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('auth_token')
        localStorage.removeItem('auth_expires')
        localStorage.removeItem('user_info')
        window.location.href = '/LogIn'
      }
      return Promise.reject(error)
    }
  )

  isBootstrapped = true
}

export const startApp = function ({ router }) {
  configureApp()

  return axios.get('/opensetting.json')
    .then(res => {
      Vue.prototype.GLOBAL = res.data
      console.log(Vue.prototype.GLOBAL)

      return new Vue({
        router,
        store,
        render: h => h(App)
      }).$mount('#app')
    })
}
